import Assignment from "../../js/ReadModel/Order/Assignment";

export default class AssignmentViewHelper {
    private _offset: number;
    constructor() {
        this._offset = 0;
    }

    get offset(): number {
        return this._offset;
    }

    set offset(value: number) {
        this._offset = value;
    }
}
